<template>
    <div>
        <!-- <div class="options d-flex align-items-center m-3">
            <search table="agents"></search>
            <export></export>
        </div> -->

        <div class="col-sm-12 mb-4">
            <div class="d-flex col-md-4 pl-0 pt-4">
                <div class="d-flex w-100">
                    <input class="glued-right bg-lighter w-100" type="text" v-model="searchString" placeholder="Search agent name">
                    <div class="glued-left dark"><i class="ico-search larger color-1"></i></div>
                </div>
            </div>

        </div>

        <div class="p-4 text-center" v-if="getIsLoadingAssociatedAgent">
            <loader></loader>
        </div>

        <div v-else>
            <list :header="header" :body="body" :rows="filteredAgents" :actions="actions"></list>

        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import List from '@/tools/list/baseList'
    import Search from '@/tools/Search'
    import Export from '@/tools/Export'
    import Loader from '@/tools/loaders/loader1'

    import { peopleMixin } from '@/mixins/people'

    export default {
        data: function() {
            return {
                searchString: null,
                body: {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    customCells: {
                        image: this.formatImage,
                        name: this.formatName,
                        role: this.formatRole,
                        status: this.formatStatus,
                    },
                    customRowEvent: this.view,
                    customClassCell: {
                        name: 'pointer',
                        phone: 'pointer',
                        email: 'pointer',
                        status: 'pointer',
                    },
                },
                actions: {
                    label : 'Actions',
                    list: [
                        /*
                        {
                            slug: 'email',
                            title: 'Email',
                            tooltip: 'Send email',
                            params: '',
                            class: '',
                            icon: 'ico-email largest',
                            event: function(item) {},
                        },
                        */
                        {
                            slug: 'edit',
                            title: 'Edit',
                            tooltip: 'Edit',
                            params: '',
                            class: '',
                            icon: 'ico-edit largest',
                            event: this.view,
                        },
                         /*
                        {
                            slug: 'invite',
                            title: 'Invite',
                            tooltip: 'Invite / Connect Agent',
                            params: '',
                            class: '',
                            icon: 'ico-add largest',
                            event: this.callInviteAgent,
                        },*/
                        /*
                        {
                            slug: 'vehicle',
                            title: 'Vehicle',
                            tooltip: 'Vehicle',
                            params: '',
                            class: '',
                            icon: 'ico-vehicle largest',
                            event: function(item) {},
                        },
                        */
                        {
                            slug: 'delete',
                            title: 'Delete',
                            tooltip: 'Delete',
                            params: '',
                            class: '',
                            icon: 'ico-delete largest',
                            event: this.remove
                        }
                    ],
                }
            }
        },
        created: function() {

        },
        computed: {
            ...mapGetters([
                'getAgents',
                'getAgentsLabels',
                'getRoles',
                'account',
                'getIsLoadingAssociatedAgent'
            ]),
            allAgents: function () {
                return this.getAgents
            },
            header: function() {
                return {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    list: {
                        image: '',
                        name: 'Name',
                        phone: 'Phone',
                        email: 'Email',
                        status: 'Status',
                    },
                };
            },
            filteredAgents: function() {
                let output = this.getAgents

                if(this.searchString != null){
                    output = output.filter(agent => {
                        return agent.brandName.toLowerCase().includes(this.searchString.toLowerCase()) || (agent.email && agent.email.toLowerCase().includes(this.searchString.toLowerCase()))
                    })
                }

                return output
            }
        },
        mixins:[
            peopleMixin
        ],
        methods: {
            ...mapActions([
                'openModal',
                'removeItem',
                'setSelectedPerson',
                'inviteAgent',
                'connectToAgent',
                'downloadAgents'
            ]),
            callInviteAgent: function(agent) {
                if(agent.isPhysicalAccountConnected && agent.isPhysicalAccountCreated){
                    this.$toasted.info('Already connected to this agent');
                    return true
                }

                if(!agent.isPhysicalAccountConnected && !agent.isPhysicalAccountCreated){
                    this.inviteAgent({
                        supplierId: this.account.supplierId,
                        agent: agent
                    }).then(response => {
                        this.downloadAgents()
                    })
                } else if (agent.isPhysicalAccountCreated) {
                    this.connectToAgent({
                        supplierId: this.account.supplierId,
                        agent: agent
                    }).then(response => {
                        this.downloadAgents()
                    })
                }
            },
            formatRole: function(person) {
                return person.role ? person.role.label : '';
            },
            formatImage: function(person) {
                return person.image ? '<img style="max-width: 100px; max-height: 100px;" src="' + person.image + '" alt="' + person.name + '">' : '';
            },
            formatName: function(person) {
                    return `<strong>` + person.brandName + `</strong>`;
                /*
                return `<strong>` + person.name + `</strong>
                        <div class="fs-smaller bold dark custom-name">
                            <a href="#">Profile</a> |
                            <a href="#">History</a>
                        </div>`;
                */
            },
            formatStatus: function(person) {
                if(person.isLoading){
                    return '<div class="loaderHolder"><div class="loader">Loading...</div></div>'
                } else {
                    return '<div style="width: 150px" class="radius-normal fs-smaller lightest radius-stadium '+this.peopleInviteStatus(person).colorClass+' p-2 font-weight-600 text-center">'+this.peopleInviteStatus(person).label+'</div>'
                }
            },
            view: function(person) {
                this.setSelectedPerson(person);
                this.openModal('AgentView');
            },
            remove: function(item) {
                if(item.isOTA){
                    this.$dialog.alert('\
                        <div class="fs-larg font-weight-600 mb-4">This action is not available for this agent.</div>\
                        <div>If you wish to cancel protocol connection with '+item.brandName+' please contact the support team</div>', {
                            okText:'Ok'
                        })
                        .then(function () {
                            //ok
                        })
                        .catch(function () {
                        });
                    return false
                } else {

                }
                this.removeItem({
                    table: 'agents',
                    object: 'AgentProtocol',
                    module: 'people',
                    fields: { supplierId: this.account.supplierId, Agent: item, by: this.account.name, }
                });
            }
        },
        components: {
            List,
            Search,
            Export,
            Loader
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .custom-name {
        a, a:hover {
            color: $dark;
        }
    }
</style>



// WEBPACK FOOTER //
// PeopleAgents.vue?85ba0a22